<template>
  <div
    v-on:click="clickModalOverlay($event);"
    class="overlay d-flex justify-content-center align-items-center h-100 rounded"
  >
    <div
      class="bg-white  slim-form  shadow-sm position-relative d-flex flex-column"
      ref="container"
    >
      <a
        v-on:click="closeItem()"
        class="close-modal"
      ><i class="fal fa-times"></i></a>
      <div v-if="item.id">
        <img
          v-if="item.image"
          v-bind:src="'/storage/menu_item_image/'+ rawMenu.user.id +'/medium/' + item.image + '?v=' + item.updated_at"
          v-bind:alt="rawMenu.user.name + ' ' + item.name"
          class="img-fluid"
        />
        <div
          class="px-4 pt-4 pb-4"
          ref="itemDescription"
        >
          <div
            v-if="item.is_sold_out"
            class="text-danger small font-weight-bold"
          >
            Sold out
          </div>
          <div
            v-if="item.is_special"
            class="badge badge-inverse mb-2 mr-1"
          >
            <i class="fal fa-tags"></i>
            Special
          </div>
          <span
            v-if="item.is_new"
            class="badge badge-inverse mb-2 mr-1"
          >NEW</span> <span
            v-if="item.is_popular"
            class="badge mb-2 mr-1"
          ><i class="far fa-heart"></i> POPULAR</span>
          <h1 class="m-0">
            {{ item.name }}
          </h1>
          <p class="m-0 mt-2 item-description">
          <pre class="font-family-1">{{ item.description }}</pre>
          </p>
          <div class="small text-muted d-filters">
            <div
              v-if="item.is_sold_out"
              class="mr-2 d-none d-lg-inline-block text-danger"
            >
              Sold out
            </div>
            <div
              v-if="item.is_vegetarian"
              class="mr-2 d-none d-lg-inline-block"
            >
              <i class="fal fa-carrot"></i>
              Vegeterian
            </div>
            <div
              v-if="item.is_vegan"
              class="mr-2 d-none d-lg-inline-block"
            >
              <i class="fal fa-seedling"></i>
              Vegan
            </div>
            <div
              v-if="item.is_gluten_free"
              class="mr-2 d-none d-lg-inline-block"
            >
              <i class="fal fa-wheat"></i>
              Gluten Free
            </div>
            <div
              v-if="item.is_dairy_free"
              class="mr-2 d-none d-lg-inline-block"
            >
              <i class="fal fa-cow"></i>
              Dairy Free
            </div>
            <div
              v-if="item.is_nut_free"
              class="mr-2 d-none d-lg-inline-block"
            >
              <i class="fal fa-acorn"></i>
              Nut Free
            </div>
            <div
              v-if="item.is_vegetarian"
              class="mr-2 d-lg-none d-inline-block"
            >
              <i class="fal fa-carrot"></i> V
            </div>
            <div
              v-if="item.is_vegan"
              class="mr-2 d-lg-none d-inline-block"
            >
              <i class="fal fa-seedling"></i>
              VG
            </div>
            <div
              v-if="item.is_gluten_free"
              class="mr-2 d-lg-none d-inline-block"
            >
              <i class="fal fa-wheat"></i> GF
            </div>
          </div>
          <div
            v-if="!onlineMenuEnabled || item.is_sold_out"
            class="m-0 mt-2"
          >

            <div
              v-for="(price,index) in item.prices"
              :key="'pr-'+index"
            >
              <div class="d-flex justify-content-between small">
                <div class="text-muted">{{ price.label }}</div>
                <div>{{ rawMenu.user.currency.symbol
                                }}{{ price.amount | centsToDollars }}</div>

              </div>
            </div>
          </div>
          <div
            class="mb-3"
            v-else
          >
            <div
              class="mt-2"
              v-if="item.prices.length>1"
              ref="priceContainer"
            >
              <div
                v-if="selectedPriceError"
                class="badge badge-danger mb-2 mr-1"
              ><i class="fad fa-exclamation-circle"></i> Select one</div>
              <div
                class="py-3 px-1 border-bottom bg-white"
                v-for="(price,index) in item.prices"
                :key="'pr-1'+index"
              >
                <label class="container-label">

                  <span class="text-muted w-80">{{ price.label }}</span>
                  <span>{{ rawMenu.user.currency.symbol }}{{ price.amount | centsToDollars}}</span>

                  <input
                    v-model="selectedPrice"
                    type="radio"
                    :value="price"
                  />

                </label>
              </div>

            </div>
          </div>

          <div
            v-if="!onlineMenuEnabled || item.is_sold_out"
            class="mt-2"
          >
            <div
              class="smaller"
              v-for="(option,index) in item.options"
              :key="index"
            >
              <div class="d-flex justify-content-between">
                <div class="text-muted w-80">{{ option.label }}</div>
                <div v-if="option.amount">+ {{
                                                                rawMenu.user
                                                                    .currency
                                                                    .symbol
                                                            }}{{
                                                                option.amount | centsToDollars
                                                            }}</div>
              </div>
            </div>
          </div>
          <div
            v-else
            ref="optionGroupContainer"
          >
            <div
              class="mt-3"
              v-if="item.options.length"
            >
              <label class="font-weight-bold">Add-ons</label>
              <div
                class="py-2 px-1 border-bottom bg-white "
                v-for="(option,index) in item.options"
                :key="index"
              >
                <label class="container-label text-muted">
                  <span class="w-80">
                    {{ option.label }}
                  </span>
                  <span v-if="option.amount">+{{ rawMenu.user.currency.symbol }}{{ option.amount | centsToDollars}}</span>
                  <input
                    v-model="option.selected"
                    type="checkbox"
                  />

                </label>
              </div>
            </div>
          </div>
          <div v-if="!onlineMenuEnabled || item.is_sold_out">
            <div
              class="py-3 px-1 my-3  bg-light rounded p-3 small"
              v-for="(group,i) in item.option_groups"
              :key="i"
            >

              <div
                class="text-muted small"
                v-if="group.is_required==1"
              >Required*</div>
              <div
                class="text-muted tiny-text"
                v-if="group.multiple_select"
              >
                <span v-if="group.min_selections==1&&group.max_selections==0">Choose a minimum of {{ group.min_selection_amount }}</span>
                <span v-if="group.min_selections==1&&group.max_selections==1">Choose a minimum of {{ group.min_selection_amount }} and up to {{ group.max_selection_amount }}</span>
                <span v-if="group.min_selections==0&&group.max_selections==1">Choose a up to {{ group.max_selection_amount }}</span>
              </div>
              <div
                class="text-muted tiny-text"
                v-else
              >Choose 1</div>

              <label class="font-weight-bold">{{ group.label}}</label>
              <div
                class="py-3 px-1 border-bottom text-muted"
                v-for="(item,i) in group.options"
                :key="i"
              >
                <div class="d-flex justify-content-between">
                  <div class="text-muted w-80">
                    {{ item.label }}</div>
                  <div v-if="item.amount">+{{ rawMenu.user.currency.symbol }}{{ item.amount | centsToDollars}}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div
              class="py-3 px-1 my-3"
              v-for="(group,i) in item.option_groups"
              :key="i"
            >
              <div
                v-if="group.hasError"
                class="badge badge-danger mb-2 mr-1"
              ><i class="fad fa-exclamation-circle"></i> {{ group.errorLabel }}</div>
              <div
                class="text-muted small"
                v-if="group.is_required==1"
              >Required*</div>
              <div
                class="text-muted tiny-text"
                v-if="group.multiple_select"
              >
                <span v-if="group.min_selections==1&&group.max_selections==0">Choose a minimum of {{ group.min_selection_amount }}</span>
                <span v-if="group.min_selections==1&&group.max_selections==1">Choose a minimum of {{ group.min_selection_amount }} and up to {{ group.max_selection_amount }}</span>
                <span v-if="group.min_selections==0&&group.max_selections==1">Choose a up to {{ group.max_selection_amount }}</span>
              </div>
              <div
                class="text-muted tiny-text"
                v-else
              >Choose 1</div>

              <label class="font-weight-bold">{{ group.label}}</label>
              <div
                class="py-3 px-1 border-bottom text-muted"
                v-for="(item,i) in group.options"
                :key="i"
              >
                <div v-if="group.multiple_select">
                  <label class="container-label">
                    <span class="text-muted w-80">{{ item.label }}</span>
                    <span v-if="item.amount">+{{ rawMenu.user.currency.symbol }}{{ item.amount | centsToDollars}}</span>
                    <input
                      v-model="item.selected"
                      type="checkbox"
                      @click="validateGroupClick(group,item)"
                    />
                  </label>
                </div>
                <div v-else>
                  <label class="container-label">
                    <span class="text-muted w-80">{{ item.label }}</span>
                    <span v-if="item.amount">+{{ rawMenu.user.currency.symbol }}{{ item.amount | centsToDollars}}</span>

                    <input
                      v-model="item.selected"
                      type="checkbox"
                      @click="validateGroupClick(group,item)"
                    />
                  </label>
                </div>

              </div>
            </div>
          </div>

          <div
            v-for="(crossSellGroup,index) in item.cross_sell_groups"
            :key="'csg-'+index"
          >
            <label class="font-weight-bold">{{ crossSellGroup.label}}</label>
            <div
              class="cs-container py-3 px-1 border-bottom text-muted"
              v-for="(csgItem,i) in crossSellGroup.items"
              :key="'cs'+i"
              @click="openCrossSell(csgItem)"
            >

              <div class="d-flex justify-content-between align-items-center">

                <div class="text-muted w-80 d-flex align-items-center">
                  <div
                    v-if="csgItem.image"
                    class="bg-light sm-image mr-3"
                    :style="{ 'background-image': 'url(' + '/storage/menu_item_image/'+ rawMenu.user.id +'/small/' + csgItem.image + '?v=' + csgItem.updated_at+ ')' }"
                  >
                    <div
                      class="cart-count"
                      v-if="cartCount(csgItem)"
                    >{{cartCount(csgItem)}}</div>
                  </div>
                  <div
                    v-else
                    class="bg-light sm-image mr-3"
                  ></div>
                  <div class="sm-name">{{ csgItem.name }}</div>

                </div>
                <div
                  v-for="(price,index) in csgItem.prices"
                  :key="'pri-'+index"
                >
                  <div class="d-flex justify-content-between">
                    <div class="text-muted">{{ price.label }}fasdfa</div>
                    <div>{{ rawMenu.user.currency.symbol
                                }}{{ price.amount | centsToDollars }}</div>

                  </div>
                </div>
                <div><i class="far fa-chevron-right"></i></div>
              </div>
            </div>
          </div>

          <div class="text-center">
            <!--<div>
              <button
                v-on:click="closeModals();"
                class="btn btn-inverse my-3 mt-4"
              >Close</button>
            </div>-->
            <!--  <div>
              <a
                v-on:click="shareVisible=true; scrollToBottom()"
                v-if="!shareVisible"
                class="btn btn-link color-1 ,mb-3"
              ><i class="fal fa-share"></i> Share</a>

            </div>-->

          </div>
          <div v-if="rawMenu.user.enable_rewards && item.punch_card_rewards.length">
            <label class="small rwd-color font-weight-bold">{{ item.punch_card_rewards[0].label}}</label>
            <div
              v-if="customer"
              class="tiny-text text-muted"
            >You have bought <span class="rwd-color font-weight-bold">{{customerAmountBought}}</span> of these. <span v-if="item.punch_card_rewards[0].items_bought_reward_threshold>customerAmountBought">Buy <span class="rwd-color font-weight-bold">{{item.punch_card_rewards[0].items_bought_reward_threshold-customerAmountBought}} more</span> and get the next one free<sup>*</sup></span><span v-else>Add this to your cart and get it for free<sup>*</sup> </span></div>
            <div
              v-else
              class="tiny-text text-muted"
            >Buy this item {{ item.punch_card_rewards[0].items_bought_reward_threshold }} times and get the <span>{{ parseInt(item.punch_card_rewards[0].items_bought_reward_threshold) + 1 }}<span v-if="item.punch_card_rewards[0].items_bought_reward_threshold==1">nd</span><span v-if="item.punch_card_rewards[0].items_bought_reward_threshold==2">rd</span><span v-if="item.punch_card_rewards[0].items_bought_reward_threshold>3">th</span> one free<sup>*</sup>. Sign-in at checkout and we will add this purchase to your tally.</span> </div>

          </div>
          <button
            v-if="onlineMenuEnabled && item.prices.length && !item.is_sold_out && !processing"
            class="btn btn-block mt-3
            add-to-cart"
            v-on:click="addToCart()"
          >Add to order <span v-if="orderAmount">| <span class="font-weight-bold">{{ rawMenu.user.currency.symbol
                                }}{{ orderAmount | centsToDollars }}</span></span>
          </button>
          <div
            class="tiny-text mt-3 text-muted text-center"
            v-if="rawMenu.user.enable_rewards && item.punch_card_rewards.length"
          >
            <sup>*</sup>Free excluding any charges or fees.
          </div>
        </div>
        <div ref="itemShare">
          <shareItem
            v-if="item && shareVisible"
            :item="item"
            :itemUrl="itemUrl"
            class="fadeInUp"
          />
        </div>
      </div>
      <formLoader
        v-if="processing"
        class="text-center my-5"
        :width="30"
      ></formLoader>
    </div>
  </div>
</template>

<style lang="scss" scoped>
h1 {
  font-size: 1.6rem;
  line-height: 1.4;
  font-weight: 700;
}
.item-description {
  font-size: 1rem;
}
.d-filters {
  font-size: 0.8rem;
}
.item-container {
  margin-bottom: 5rem;
}
.add-to-cart {
  text-align: center;
  font-weight: 600;
  color: #fff;
  padding: 1rem;
  background-color: var(--user-highlight-color);
  border-color: var(--user-highlight-color);
  cursor: pointer;
  border-radius: 10rem;
  font-size: 1.3rem;
}
.badge-danger {
  background-color: rgb(255, 239, 237) !important;
  border-color: rgb(255, 239, 237) !important;
  color: rgb(225, 25, 0) !important;
}
.cs-container {
  cursor: pointer;
}
.sm-image {
  width: 30%;
  height: 3rem;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 0.5rem;
  position: relative;
}
.sm-name {
  width: 70%;
}
.cart-count {
  border-radius: 50%;
  text-align: center;
  font-weight: 600;
  color: #fff;
  width: 1rem;
  height: 1rem;
  background-color: var(--user-highlight-color);
  border-color: var(--user-highlight-color);
  font-size: 0.5rem;
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 0.15rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rwd-color {
  color: var(--user-highlight-color);
}
</style>

<script>
import menuMixin from "../../../mixins/menuMixin";
import accountingMixin from "../../../mixins/accountingMixin";
import customerMixin from "../../../mixins/customerMixin";
import formLoader from "../../form/FormLoader";
import shareItem from "./ShareItem";
import cartMixin from "../../../mixins/cartMixin";
var VueScrollTo = require("vue-scrollto");

export default {
  beforeDestroy() {
    if (this.activeModal != "viewItem") {
      this.$router
        .push({
          name: "menuIndex",
          params: {
            userSlug: this.rawMenu.user.slug,
          },
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.getItem();
    this.getCustomer();
  },
  data() {
    return {
      item: {},
      shareVisible: false,
      processing: false,
      selectedPrice: null,
      selectedPriceError: false,
    };
  },
  metaInfo() {
    return {
      title: this.metaTags.title,
      titleTemplate: this.metaTags.titleTemplate,
      vmid: "title",
      meta: [
        {
          name: "description",
          vmid: "description",
          content: this.metaTags.description,
        },
        {
          name: "og:title",
          vmid: "ogTitle",
          content: this.metaTags.title,
        },
        {
          name: "og:description",
          vmid: "ogDescription",
          content: this.metaTags.description,
        },
        {
          name: "og:image",
          vmid: "ogImage",
          content: this.metaTags.image,
        },
      ],
      script: this.metaTags.scripts,
      link: this.metaTags.links,
    };
  },
  methods: {
    closeItem: function () {
      this.closeModals();

      if (
        this.$route.query.nextroute &&
        this.$route.query.nextroute == "menuItem"
      ) {
        let itemSlug = this.$route.query.itemslug;
        let categorySlug = this.$route.query.categoryslug;
        this.$nextTick(() => {
          this.$router.push({
            name: "menuItem",
            params: {
              itemSlug: itemSlug,
              categorySlug: categorySlug,
              userSlug: this.rawMenu.user.slug,
            },
          });
        });
      }
    },
    openCrossSell: function (item) {
      this.closeModals();
      this.$nextTick(() => {
        this.$router
          .push({
            name: "menuItem",
            params: {
              itemSlug: item.slug,
              categorySlug: item.category.slug,
              userSlug: this.rawMenu.user.slug,
            },
            query: {
              nextroute: "menuItem",
              itemslug: this.item.slug,
              categoryslug: this.item.category.slug,
            },
          })
          .catch(() => {});
      });
    },
    cartCount(item) {
      if (this.cartItems) {
        let quantity = 0;
        _.forEach(this.cartItems, function (iValue, iKey) {
          if (iValue.id == item.id) {
            _.forEach(iValue.prices, function (pValue, cKey) {
              if (pValue.selected == true) {
                quantity = quantity + iValue.quantity;
              }
            });
          }
        });
        return quantity;
      }
      return false;
    },
    getItem: function () {
      this.processing = true;
      axios.get(this.itemUrl).then(
        (response) => {
          this.processing = false;
          this.item = response.data;

          this.$gtag.pageview({
            page_title: this.rawMenu.user.name + " : " + this.item.name,
          });
          this.setSelectedMenuItemId(this.itemIdPrefix + this.item.slug);
          this.$nextTick(() => {
            let el = this.$refs.itemDescription;
            let container = this.$refs.container;
            var options = {
              container: container,
              easing: "ease-in",
              lazy: false,
              offset: 0,
              force: true,
              cancelable: true,
              onStart: function (element) {
                // scrolling started
              },
              onDone: function (element) {
                // scrolling is done
              },
              onCancel: function () {
                // scrolling has been interrupted
              },
              x: false,
              y: true,
            };
            VueScrollTo.scrollTo(el, 500, options);
          });

          if (this.item.prices.length == 1) {
            this.selectedPrice = this.item.prices[0];
          }
        },
        (error) => {
          if (error.response.status == 404) {
            this.$router
              .push({
                name: "404",
              })
              .catch((err) => {});
          }
        }
      );
    },
    scrollToBottom: function () {
      let el = this.$refs.itemShare;
      let container = this.$refs.container;
      var options = {
        container: container,
        easing: "ease-in",
        lazy: false,
        offset: 0,
        force: true,
        cancelable: true,
        onStart: function (element) {
          // scrolling started
        },
        onDone: function (element) {
          // scrolling is done
        },
        onCancel: function () {
          // scrolling has been interrupted
        },
        x: false,
        y: true,
      };
      VueScrollTo.scrollTo(el, 500, options);
    },
    addToCart: function () {
      this.selectedPriceError = false;
      let container = this.$refs.container;
      let options = {
        container: container,
        easing: "ease-in",
        lazy: false,
        offset: 0,
        force: true,
        cancelable: true,
        onStart: function (element) {
          // scrolling started
        },
        onDone: function (element) {
          // scrolling is done
        },
        onCancel: function () {
          // scrolling has been interrupted
        },
        x: false,
        y: true,
      };

      //prices
      if (!this.selectedPrice) {
        let el = this.$refs.priceContainer;
        this.selectedPriceError = true;

        VueScrollTo.scrollTo(el, 500, options);
        return false;
      }

      //option groups

      let optionGroupError = false;

      _.forEach(this.item.option_groups, function (cValue, cKey) {
        let selectCount = 0;
        cValue.hasError = false;
        cValue.errorLabel = "";

        _.forEach(cValue.options, function (oValue, oKey) {
          if (oValue.selected == true) {
            selectCount++;
          }
        });
        // validate required
        if (cValue.is_required) {
          if (selectCount == 0) {
            cValue.hasError = true;
            cValue.errorLabel = "Required";
            optionGroupError = true;
            return false;
          }
        }
        if (cValue.multiple_select) {
          // validate min amount
          if (cValue.is_required) {
            if (cValue.min_selections) {
              if (selectCount < cValue.min_selection_amount) {
                cValue.hasError = true;
                cValue.errorLabel =
                  "Choose a minimum of " + cValue.min_selection_amount;
                optionGroupError = true;
              }
            }
          }
          //if selected min but not required
          if (cValue.min_selections && selectCount > 0) {
            if (selectCount < cValue.min_selection_amount) {
              cValue.hasError = true;
              cValue.errorLabel =
                "Choose a minimum of " + cValue.min_selection_amount;
              optionGroupError = true;
            }
          }
          // validate max amount
          if (cValue.max_selections) {
            if (selectCount > cValue.max_selection_amount) {
              cValue.hasError = true;
              cValue.errorLabel =
                "Choose a maximum of " + cValue.max_selection_amount;
              optionGroupError = true;
            }
          }
        }
      });

      this.item.option_groups = _.cloneDeep(this.item.option_groups);

      if (optionGroupError) {
        let el = this.$refs.optionGroupContainer;
        VueScrollTo.scrollTo(el, 500, options);
        return false;
      }

      this.processing = true;
      let formData = new FormData();
      let _self = this;
      _.forEach(this.item.prices, function (opValue, opKey) {
        if (opValue.id == _self.selectedPrice.id) {
          opValue.selected = true;
        }
      });
      this.item.prices = _.cloneDeep(this.item.prices);
      this.item.quantity = 1;

      formData.append("item", JSON.stringify(this.item));
      formData.append("_method", "PATCH");

      axios
        .post("/api/customer/cart", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          }.bind(this),
        })
        .then(
          (response) => {
            this.processing = false;
            this.error = null;
            if (response.data) {
              this.refreshMenu(this.$route.params.userSlug);
              this.refreshCart();
              this.closeModals();
              if (
                this.$route.query.nextroute &&
                this.$route.query.nextroute == "menuItem"
              ) {
                let itemSlug = this.$route.query.itemslug;
                let categorySlug = this.$route.query.categoryslug;
                this.$nextTick(() => {
                  this.$router.push({
                    name: "menuItem",
                    params: {
                      itemSlug: itemSlug,
                      categorySlug: categorySlug,
                      userSlug: this.rawMenu.user.slug,
                    },
                  });
                });
              }
            }
          },
          (error) => {
            this.errors = error.response.data.errors;
            this.processing = false;
          }
        );
    },
    validateGroupClick: function (group, item) {
      if (!group.multiple_select) {
        _.forEach(group.options, function (cValue, cKey) {
          if (cValue.id !== item.id) {
            cValue.selected = false;
          }
        });
      } else {
        if (group.max_selections) {
          var selectCount = 1;
          if (!item.selected == true || !item.selected) {
            _.forEach(group.options, function (cValue, cKey) {
              if (cValue.selected == true) {
                selectCount++;
                if (selectCount > group.max_selection_amount) {
                  cValue.selected = false;
                  selectCount--;
                }
              }
            });
          }
        }
      }
      group.options = _.cloneDeep(group.options);
    },
  },
  components: {
    formLoader,
    shareItem,
  },
  mixins: [accountingMixin, menuMixin, cartMixin, customerMixin],
  computed: {
    orderAmount: function () {
      let amount = 0;
      if (this.item) {
        if (this.selectedPrice) {
          amount = amount + this.selectedPrice.amount;
        }

        _.forEach(this.item.options, function (cValue, cKey) {
          if (cValue.selected) {
            amount = amount + cValue.amount;
          }
        });
        _.forEach(this.item.option_groups, function (cValue, cKey) {
          _.forEach(cValue.options, function (oValue, cKey) {
            if (oValue.selected) {
              amount = amount + oValue.amount;
            }
          });
        });
      }
      return amount;
    },
    customerAmountBought: function () {
      let amount = 0;
      if (this.customer && this.item) {
        let _self = this;
        if (_self.item.punch_card_rewards[0]) {
          _.forEach(_self.customer.punch_card_rewards, function (cValue, cKey) {
            if (cValue.id == _self.item.punch_card_rewards[0].id) {
              amount = cValue.pivot.tally;
            }
          });
        }
      }
      return amount;
    },
    itemUrl: function () {
      return (
        "/api/" +
        this.$route.params.userSlug +
        "/menu/items/" +
        this.$route.params.categorySlug +
        "/" +
        this.$route.params.itemSlug
      );
    },
    metaTags: function () {
      let tags = {
        title: "Menu Item",
        titleTemplate: "%s | Happy Menu",
        description: "",
        image: "",
        scripts: [],
        links: [],
      };
      if (this.item) {
        tags.title = this.rawMenu.user.name + " : " + this.item.name;
        tags.description = this.item.description;
        if (this.item.image) {
          tags.image =
            "https://www.happymenu.co/storage/menu_item_image/" +
            this.rawMenu.user.id +
            "/medium/" +
            this.item.image;
        }
        tags.links = [
          {
            rel: "canonical",
            href: "https://www.happymenu.co/" + this.rawMenu.user.slug,
          },
        ];
      }
      return tags;
    },
  },
};
</script>
